import { submitApplication, submitGroupCode } from './application';
import { focusQuestion, selectContext } from './context';

const pertinent = [focusQuestion, submitApplication, submitGroupCode].map((action) =>
  action.typePrefix ? `${action.typePrefix}/fulfilled` : action.type,
);

/**
 * Middleware for publishing events out based on actions
 */
const publisher =
  ({ onApplicationSubmit = () => {}, onQuestionFocus = () => {} }) =>
  (store) =>
  (next) =>
  (action) => {
    const result = next(action);
    if (!pertinent.includes(action.type)) {
      return result;
    }

    const state = store.getState();
    const context = selectContext(state);
    switch (action.type) {
      case focusQuestion.type:
        // Emit an event when a question is focused
        onQuestionFocus({
          index: action.payload,
          question: context.pendingApplication?.applicationForm?.questions?.[action.payload],
        });
        break;
      case `${submitApplication.typePrefix}/fulfilled`:
      case `${submitGroupCode.typePrefix}/fulfilled`:
        // Emit an event when an application or group code is submitted
        onApplicationSubmit({
          affiliationStatus: result.payload.affiliationStatus,
          applicationStatus: result.payload.applicationStatus,
          applicationType: result.payload.teamApplication?.applicationType,
          errorCode: result.payload.errorCode,
          hasError: result.payload.hasError,
          isApproved: result.payload.isApproved,
          isPending: result.payload.isPending,
          isSubmitted: result.payload.isSubmitted,
          locationId: result.payload.teamApplication?.location?.locationId,
          memberNumber: result.payload.teamApplication?.memberNumber,
          referer: action.payload.referer,
          referredOrgId: action.payload.referredOrgId,
          teamApplicationFormId: result.payload.teamApplication?.applicationForm?.teamApplicationFormId,
          teamCode: result.payload.teamApplication?.teamCode?.code,
          teamId: result.payload.teamApplication?.team?.teamId,
          teamType: result.payload.teamApplication?.team?.type,
        });
        break;
      default:
    }

    return result;
  };

export default publisher;
